import React, { useEffect } from "react";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { useScModel } from "../scModel";
import { useDictModel } from "@/views/base/dict/dictModel";
import { IScDetail } from "../scTypes";
import { formatNum } from "@/utils/utils";


export function DataTable () {
    const {
        dataSource, selectedRowKeys, pgCfg, loading,
        loadData, setSelectedRowKeys
    } = useScModel();

    const { getTreeNodeName, getTreeNodeValue } = useDictModel(() => []);

    useEffect(() => {
        loadData()
    }, [])

    const columns: ColumnsType<IScDetail> = [
        {
            title: '序号',
            width: 45,
            fixed: "left",
            dataIndex: "totalTxt",
            render: (t: any, r: any, i: number) => <>{t ? t : i + 1}</>
        }, {
            title: '客户名称',
            width: 100,
            dataIndex: 'customerName',
        }, {
            title: '客户来源',
            width: 100,
            dataIndex: 'source',
        }, {
            title: '贸易国别',
            width: 160,
            dataIndex: 'countryName',
        }, {
            title: '商品类型',
            width: 160,
            dataIndex: 'typeName',
            ellipsis: true,
        }, {
            title: '合同总金额',
            width: 160,
            dataIndex: 'amount',
            ellipsis: true,
            render: (text: any, record: any) => `${getTreeNodeValue(record.currencyCode)}${formatNum(text)}`,
        }, {
            title: '合同数量',
            width: 160,
            dataIndex: 'num',
        }
    ];


    //点击行选高亮
    const onRow = (code: string) => {
        let findIndex = selectedRowKeys.indexOf(code);
        let newSelectedRowKeys = [...selectedRowKeys];
        if (findIndex === -1) {
            newSelectedRowKeys.push(code);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            newSelectedRowKeys.splice(findIndex, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };


    return (
        <Table
            rowKey={record => record.id}
            loading={loading}
            rowSelection={{
                //全部选中时  (存string[])
                onSelectAll: (selected, selectedRows, changeRows) => {
                    let changeRowId = changeRows.map(item => item.id).filter(item => item !== "listTotalAmount");
                    selected ? setSelectedRowKeys((origin) => [...origin, ...changeRowId])
                        : setSelectedRowKeys((origin) => origin.filter(item => changeRowId.indexOf(item) < 0));
                },
                onSelect: (record) => onRow(record.id),
                selectedRowKeys: selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record.id),
                onContextMenu: (e) => {
                    e.preventDefault();
                    setSelectedRowKeys([record.id]);
                }
            })}
            scroll={{ x: 'max-content', y: "calc(100vh - 360px)" }}
        />
    )
}
